import { render, staticRenderFns } from "./OcrModal.vue?vue&type=template&id=6303a2cd&scoped=true"
import script from "./OcrModal.vue?vue&type=script&lang=js"
export * from "./OcrModal.vue?vue&type=script&lang=js"
import style0 from "./OcrModal.vue?vue&type=style&index=0&id=6303a2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303a2cd",
  null
  
)

export default component.exports